import L from 'leaflet';
import 'leaflet-rotatedmarker';
import HttpService from '../../providers/http-service.js';
import MarkerPopup from '../popup/marker-popup.js';

export default class PhotoMarker extends L.Marker {
    constructor(info, oid, index, photosWindow, map) {
        super();
        this.oid = oid;
        this.map = map;
        this.photoName = info.photo_name;
        this.photoTime = info.tm;
        this.photoIndex = index;
        this.path = '../../../../';
        this.type = 'photo';
        this.photosWindow = photosWindow;
        this._latlng = this._getMarkerPosition(info.lat, info.lon);
        this.options.icon = this._getObjectIcon();
        this.addEventListener('click', (event) => !this.map.isClickBlocked() && this._onClickMarker(event));
    }

    getWidthForColision() {
        return 10;
    }

    getHeightForColision() {
        return 34;
    }

    getMarginLeftForColision() {
        return -10;
    }

    getMarginTopForColision() {
        return 0;
    }

    _getMarkerPosition(lat, lon) {
        if ((lat > 90) || (lat < -90)) {
            return new L.LatLng(0, 0);
        }
        else
            return new L.LatLng(lat, lon);
    }

    _getObjectIcon() {
        let iconUrl = this.path + 'img/photo_marker.png';
        return L.icon({
            iconUrl: iconUrl,
            iconAnchor: [10, 34],
            iconSize: [20, 34],
        });
    }

    _onClickMarker(e) {
        this.photosWindow.fireEvent('setSrc', {
            oid: this.oid,
            photoName: this.photoName,
            photoTime: this.photoTime,
            photoIndex: this.photoIndex
        });
        this.photosWindow.show();
    }

    _makeShowPhotosWindowEvent() {
        let event = new CustomEvent('ext:showPhotosWindow', { detail: { 'photoIndex': this.photoIndex } });
        document.dispatchEvent(event);
    }

    delete() {
        this.removeEventListener('click', this._onClickMarker);
    }
}
